/**
 * YovoTrip design system — Phase 1: colors + typography wired globally.
 * Figma tokens: colors, typography. Layout helper: responsive() (breakpoints).
 *
 * @example
 * import { ThemeProvider, getTextStyle, colors, responsive } from '../theme';
 * theme.palette.tokens.neutral[900]
 */
export { default as appTheme, createAppTheme } from './createAppTheme';
export { default as ThemeProvider } from './ThemeProvider';
export * from './tokens';
export { responsive, responsiveLayout, containerPx, DESKTOP_BREAKPOINT, MOBILE_TABLET_MAX, mediaQueries } from './responsive';
